import styled from '@emotion/styled'

export const Subtitle1 = styled.p(({ theme }) => ({
  fontFamily: theme.typography.family.default,
  fontSize: '1rem',
  lineHeight: 1.5,
  fontWeight: 500,
  letterSpacing: 1,
  margin: 0,
  padding: 0,
}))
